// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"675":"e14c317e","977":"04d39699"}[chunkId] + ".css";
};